<template>
	<header class="header" :class="isTransparent == false ? 'shadow' : ''"
		:style="{ backgroundColor: isTransparent == true ? 'transparent' : isTransparent == false ? '#ffffff' : '' }">
		<div class="header-content flex-row">
			<div class="companyInfo flex-row" @click="to('/')">
				<div><img src="../../../assets/header/logo.png" /></div>
			</div>
			<nav class="nav flex-row">
				<ul class="nav-container ">
					<li class="nav-li"><router-link active-class="nav-active" class="nav-li-link"
							to="/home">首页</router-link></li>
					<li class="nav-li"><router-link active-class="nav-active" class="nav-li-link"
							to="/tradingSquare">产品与服务</router-link></li>
					<li class="nav-li"><router-link active-class="nav-active" class="nav-li-link"
							to="/productPackage">产品套餐</router-link></li>
					<li class="nav-li"><router-link active-class="nav-active" class="nav-li-link"
							to="/complianceStudy">药销通合规学苑</router-link></li>
					<li class="nav-li"><router-link active-class="nav-active" class="nav-li-link"
							to="/contactUs">关于我们</router-link></li>
				</ul>
				<div class="user flex-row flex-center">
					<span style="margin-right: 20px; font-size:16px">400-901-3689转1</span>
					<el-button @click="toOpen">企业版登录</el-button>
				</div>
			</nav>
		</div>
	</header>
</template>
<script>
export default {
	props: ['isTransparent'],
	data() {
		return {
			quitWindows: false
		};
	},
	methods: {
		to() {
			this.$router.push('/');
		},
		toOpen() {
			window.open("https://psp.yaoxiaotong.cn/")
		},

		operation(type) {
			if (type[0] == 'clear') {
				this[type[1]] = false;
			}
			if (type[0] == 'sure') {
				this[type[1]] = false;
			}
			if (type[0] == 'close') {
				this[type[1]] = false;
			}
		}
	},
	computed: {}
};
</script>
<style scoped lang="scss">
.shadow {
	box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
}

.userPopover {
	padding: 10px;
	height: auto;
	justify-content: space-between;

	img {
		width: 13px;
		height: 13px;
		margin-right: 10px;
	}

	div {
		align-items: center;
	}

	&>div:nth-child(2) {
		margin: 20px 0;
	}
}

.withUl {
	align-items: center;

	li {
		list-style: none;
		text-decoration: none !important;
		margin-bottom: 19px;
	}

	& li:last-child {
		margin-bottom: 0px;
	}
}

.nav {
	align-items: center;
	margin-left: 130px;

	.user {
		position: absolute;
		right: 0px;

		.el-button {
			width: 112px;
			height: 40px;
		}

		span {
			font-size: 14px;
			color: #333333;
		}
	}

	.nav-container {
		font-size: $global-header-font-size;
		list-style: none;

		.nav-li {
			float: left;
			margin-right: 37px;
			height: 40px;

			.nav-li-link {
				height: 40px;
				color: $global-header-companyName-Color;
				line-height: 40px;
				padding: 8px 0px;
			}

			.nav-li-link:hover {
				color: $global-default-primary;
			}
		}
	}
}

.nav-active {
	color: $global-header-activeNav-color !important;
	font-weight: $global-header-font-weight;
}

.header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 76px;
	z-index: 999;
	transition: all 0.4s;
	// background-color: white;
}

.header-content {
	width: $global-content-width;
	margin: 0 auto;
	// justify-content: space-between;
	height: $global-header-height;
	padding: 15px 0;
	position: relative;
}

.companyInfo {
	cursor: pointer;
}

.companyInfo img {
	height: 50px;
}

.company {
	align-items: center;
}</style>
